import { render, staticRenderFns } from "./Simbg.vue?vue&type=template&id=2f443754&scoped=true&"
import script from "./Simbg.vue?vue&type=script&lang=js&"
export * from "./Simbg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f443754",
  null
  
)

export default component.exports